import { useFeatureGate } from '@statsig/expo-bindings';

import { FeatureFlags } from '../../feature-flags/FeatureFlags';
import { requestBuilder } from '../../http/RequestBuilder';
import type { GetApexPerformanceResponse } from '../types/performance';

const useGetAccountPerformanceQuery = requestBuilder.query<
    GetApexPerformanceResponse,
    { accountId: string }
>({
    endpoint: ({ accountId }) => `/api/investments/${accountId}/performance`,
    queryKey: ({ accountId }) => `/api/investments/${accountId}/performance`,
});

const useGetPortfolioPerformanceQuery =
    requestBuilder.query<GetApexPerformanceResponse>({
        endpoint: () => '/api/investments/user-performance',
        queryKey: () => '/api/investments/user-performance',
    });

export const useGetApexAccountPerformance = (accountId: string) => {
    const { value: enableApexAccountPerformance } = useFeatureGate(
        FeatureFlags.ENABLE_APEX_ACCOUNT_PERFORMANCE,
    );

    return useGetAccountPerformanceQuery(
        { accountId },
        {
            enabled:
                enableApexAccountPerformance && accountId.trim().length > 0,
        },
    );
};

export const useGetApexPortfolioPerformance = () => {
    const { value: enableApexAccountPerformance } = useFeatureGate(
        FeatureFlags.ENABLE_APEX_ACCOUNT_PERFORMANCE,
    );

    return useGetPortfolioPerformanceQuery(undefined, {
        enabled: enableApexAccountPerformance,
    });
};
